import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';

export default function ConfirmDialog({
  open,
  title = 'Confirm',
  message,
  onClose,
  onConfirm,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          background: 'linear-gradient(135deg, #111111 0%, #1a1a1a 100%)',
          border: '1px solid rgba(255,255,255,0.1)',
          borderRadius: '12px',
          minWidth: 360,
        },
      }}
    >
      <DialogTitle
        sx={{
          color: 'white',
          fontWeight: 700,
          fontSize: '1.1rem',
          borderBottom: '1px solid rgba(255,255,255,0.08)',
          pb: 2,
        }}
      >
        {title}
      </DialogTitle>

      <DialogContent sx={{ pt: '16px !important' }}>
        <p className="text-gray-400 text-sm leading-relaxed">{message}</p>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, pt: 1, gap: 1 }}>
        <button
          onClick={onClose}
          className="px-4 py-2 text-sm text-gray-400 hover:text-white rounded-lg border border-white/10 hover:border-white/30 transition-all duration-200"
        >
          {cancelText}
        </button>
        <button
          onClick={onConfirm}
          className="px-4 py-2 text-sm font-semibold text-white rounded-lg bg-gradient-to-r from-red-600 to-red-500 hover:opacity-90 border border-red-500/30 transition-all duration-200"
        >
          {confirmText}
        </button>
      </DialogActions>
    </Dialog>
  );
}
